import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 获取某人的订阅
export function queryAllMailSubscribes(params) {
  return request({
    url: URL.price.mailSubscribe.queryAllMailSubscribes,
    method: 'post',
    params
  })
}
// 保存或删除订阅
export function saveMailSubscribes2(data) {
  return request({
    url: URL.price.mailSubscribe.saveMailSubscribes2,
    method: 'post',
    data
  })
}
// 保存或修改订阅
export function saveOrUpdateMailSubscribes(data) {
  return request({
    url: URL.price.mailSubscribe.saveOrUpdateMailSubscribes,
    method: 'post',
    data
  })
}
// 订阅管理-列表查询
export function getMailSubscribes(data) {
  return request({
    url: URL.price.mailSubscribe.getMailSubscribes,
    method: 'post',
    data
  })
}
// 订阅管理-批量删除订阅信息
export function deleteMailSubscribes(data) {
  return request({
    url: URL.price.mailSubscribe.deleteMailSubscribes,
    method: 'post',
    data
  })
}
